<template>
  <div>
  <div class="time-slot" :class="applied.length >= required ? 'full' : 'available'">
    <input type="checkbox" :id="hash">
    <label :for="hash">{{ time }}</label>
    <span>{{ applied.length }} / {{ required }}</span>
    <ul>
      <li v-for="user of applied" :key="user.name">
        {{ user.name }}
      </li>
    </ul>
  </div>
    <b-card title="Card Title"
          img-src="https://lorempixel.com/600/300/food/5/"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem;"
          class="mb-2">
    <p class="card-text">
      Some quick example text to build on the card title and make up the bulk of the card's content.
    </p>
    <b-button href="#" variant="primary">Go somewhere</b-button>
  </b-card>
  </div>
</template>

<script>
export default {
  props: ['time', 'hash', 'required', 'applied']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Slot.vue